import { FALLBACK_SEPARATOR } from './constants';
/**
 * Extract the CSS variable from a given CSS variable function call
 *
 * @param cssVarFunc CSS variable function, e.g. `var(--variable)`
 * @returns Extracted variable from the CSS variable function or null if unavailable
 */
export function cssVarFromCssVarFunc(cssVarFunc) {
    return cssVarFunc.substring('var('.length, cssVarFunc.indexOf(cssVarFunc.includes(FALLBACK_SEPARATOR) ? FALLBACK_SEPARATOR : ')'));
}
